import React from "react";
import { Button, Icon, Popup } from "semantic-ui-react";

const ViewToggle = (props) => {
  return (
    <div className="gridBoxDiv">
      <Popup
        content="Standard View"
        trigger={
          <Button
            className={props.defaultView ? "primary" : ""}
            name="default"
            onClick={() => props.click("default")}
          >
            <Icon name="list ul" />
          </Button>
        }
      />
      <Popup
        content="Detailed View"
        trigger={
          <Button
            name="detailed"
            className={!props.defaultView ? "primary" : ""}
            onClick={() => props.click("detailed")}
          >
            <Icon name="server" />
          </Button>
        }
      />
    </div>
  );
};

export default ViewToggle;
